// Keeps a progress bar / "processing" state visible for a minimum duration so a
// fast analysis run doesn't flash-complete (which reads as "it didn't do anything").
//
// Pass the timestamp captured when the run started; this waits only for the
// REMAINDER needed to reach `minMs`. Runs that already took longer than `minMs`
// return immediately — no pointless extra delay on the long runs where the user
// is already waiting. 500ms is enough to kill the flicker while staying under the
// ~1s threshold at which a wait stops reading as instant (Nielsen's response-time limits).
export function waitRemaining(startTime, minMs = 500) {
    const elapsed = Date.now() - startTime;
    if (elapsed < minMs) {
        return new Promise(resolve => setTimeout(resolve, minMs - elapsed));
    }
    return Promise.resolve();
}
